import { CircularProgress, Stack } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useParams } from "react-router-dom";
import { BoatOptionsProvider } from "../Boats/BoatOptionsContext";
import { BoatFormWrapper } from "../Boats/BoatFormWrapper";
import { DealerApplicationSummary } from "./DealerApplicationSummary";
import { DealerApplicationProgress } from "./DealerApplicationProgress";
import { BasicDetailFields } from "../Boats/BasicDetailFields";
import { BoatSpecificationFields } from "../Boats/BoatSpecificationFields";
import { DealerBoatDocumentationSection } from "./DealerBoatDocumentationSection";
import { DealerInvoiceActionSection } from "./DealerInvoiceActionSection";
import { BoatWizardModal } from "./BoatWizardModal";
import FormikDateMetaFields from "@poseidon/ui/components/form/FormikDateMetaFields";
import { useApplicationSummary } from "../Applications/hooks/useApplicationSummary";
import { ApplicationStateWarning } from "./ApplicationStateWarning";

export default function EditApplication() {
  const { setError } = useErrorMessage();
  const { applicationId } = useParams();
  const { application, loading, error } = useApplicationSummary(applicationId);
  if (error) {
    setError(error);
  }

  if (loading || !application) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  const boat = application.vessel;
  const isLocked = application.lock_dealer;
  return (
    <BoatOptionsProvider>
      <BoatFormWrapper
        boat={boat}
        title="Manage Application"
        readonly={isLocked}
        asDealer
      >
        <ApplicationStateWarning application={application} />
        <DealerApplicationSummary application={application} />
        <DealerApplicationProgress application={application} boat={boat} />
        <BasicDetailFields asDealer />
        <BoatSpecificationFields asDealer />
      </BoatFormWrapper>
      <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
        <DealerBoatDocumentationSection application={application} />
        <DealerInvoiceActionSection application={application} />
        <BoatWizardModal boat={boat} />
        <FormikDateMetaFields values={boat} />
      </Stack>
    </BoatOptionsProvider>
  );
}
